import { Routes, Route, Outlet } from 'react-router-dom';
import AgencyProfile from './AgencyProfile';
import ProfileSetting from './ProfileSetting';
import ChangePassword from './ChangePassword';
import { PERMISSIONS_SUBJECTS } from '../Auth/constants';
import { ROOT } from 'configs/routeNames';
import { AuthorizedRoute } from 'app/atoms';
import { PermissionActions } from '../Auth/types';

export default function Profile() {
  return (
    <>
      <Routes>
        <Route
          path="agency"
          element={
            <AuthorizedRoute
              requiredPermissions={[
                { action: PermissionActions.VIEW_AGENCY_DETAILS, subject: PERMISSIONS_SUBJECTS.AGENCY },
              ]}
              Component={AgencyProfile}
              redirect={ROOT}
            />
          }
        />
        <Route path="setting" Component={ProfileSetting} />
        <Route path="change-password" Component={ChangePassword} />
      </Routes>
      <Outlet />
    </>
  );
}
